import { SExpandList } from '@/components/message-center/styles/MessageCenter.styled';
import styled from 'styled-components';

export const STemplateMaintenanceContainer = styled.div`
  padding: 10px;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;

  .templates-container {
    border-radius: 15px;

    .templates-header {
      display: flex;

      > a {
        align-self: center;
        padding: 20px;
      }
    }
  }
`;

export const GridContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  border-top-left-radius: 8px;
  flex: 1;
  min-width: 0;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  position: relative;

  .k-grid-container {
    overflow: hidden;
  }

  tr {
    white-space: nowrap;
  }

  .ml__kendo-grid {
    margin-left: 18px;
  }

  .ml__kendo-grid table:hover {
    border-top-left-radius: 0px;
  }

  .k-grid-header th.k-grid-header-sticky,
  .k-master-row.k-alt .k-grid-content-sticky,
  .k-grid-content-sticky {
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};
    border: 0;
    border-radius: 0px;
    padding: 12px;
  }

  .k-grid table tr:hover .k-grid-header-sticky {
    color: inherit;
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  }

  .k-master-row:hover .k-grid-content-sticky,
  .k-master-row:hover .k-grid-row-sticky,
  .k-master-row.k-state-hover .k-grid-content-sticky,
  .k-master-row.k-state-hover .k-grid-row-sticky {
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};
  }
`;

export const STemplateListDiv = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  overflow: hidden;

  &:hover ${SExpandList} {
    color: ${({ theme }) => theme.colors.tertiaryText};
    cursor: pointer;
    display: block;
    height: 0;
    position: relative;
    right: -14px;
    top: 5px;
    width: 0;
    z-index: 1;
  }
`;
